import "../scss/page.scss";

import '../components/diagnostic';
import {
    btnAddToCart,
    deleteItem,
    onChangeItemCart,
    onLoadEmptyCart,
    openCartFromHeader,
    openCloseCart,
  } from '../components/cart';

import { stickyCart } from "../components/sticky-cart";
import initLPReviews from '../components/lp-reviews';

initLPReviews();
stickyCart();

btnAddToCart('.add-product-cart-upsell');
 